import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=6d3b8a14&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3b8a14')) {
      api.createRecord('6d3b8a14', component.options)
    } else {
      api.reload('6d3b8a14', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=6d3b8a14&", function () {
      api.rerender('6d3b8a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataEntry/components/tab.vue"
export default component.exports